import { useMemo } from "react";
import PropTypes from "prop-types";
import Collapse from "../../../Collapse";
import styles from "./styles.module.css";
import HistoryCollapseHeader from "./HistoryCollapseHeader";
import HistoryExpandContent from "./HistoryExpandContent";
import NoHistory from "./NoHistory";
const ConsentHistory = ({ history, digitalIdentity }) => {
  const sortedHistory = useMemo(() => {
    return history?.sort((a, b) => new Date(b.valid_to) - new Date(a.valid_to));
  }, [history]);

  const items = sortedHistory?.map((item, index) => ({
    key: `item-${index + 1}`,
    header: (
      <HistoryCollapseHeader
        status={item?.status}
        lastChannel={item?.last_update_channel}
        dateTime={item?.valid_from}
      />
    ),
    content: <HistoryExpandContent {...item} digitalIdentity={digitalIdentity} />,
  }));
  return (
    <div className={styles["info-container"]}>
      {items?.length ? (
        <Collapse
          items={items}
          containerStyles={styles["collapse-container"]}
          itemStyles={styles["collapse-item"]}
          headerStyles={styles["collapse-header"]}
        />
      ) : (
        <NoHistory />
      )}
    </div>
  );
};

ConsentHistory.propTypes = {
  history: PropTypes.array,
  digitalIdentity: PropTypes.object,
};

export default ConsentHistory;
